//@ts-strict-ignore
import { IFormAction } from '../../@types/entityTypes';
import React, { ReactElement, useContext, useState } from 'react';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import WorkspaceContext from '../../components/Context/WorkspaceContext';
import { useActionProps } from '../../utils/useActionProps';
import ModalContext from '../../components/Context/ModalContext';
import DocumentModal2 from '../../components/modals/DocumentModal2';
import ProductLabelBasic from '../../graphql/entities/product/ProductLabelBasic';
import { ProductFormAction } from './ProductFormAction';
import { IWorkspaceAction } from '../../@types/workspaceTypes';
import { ProductWorkspaceAction } from './ProductWorkspaceAction';

export const useProductLabelBasicAction: () => [
  IFormAction<ProductFormAction> | IWorkspaceAction<ProductWorkspaceAction>,
  ReactElement
] = () => {
  const connectedForm = useContext(ConnectedFormContext);
  const workspace = useContext(WorkspaceContext);

  //If workspace context has the default value, must be a form (Forms cannot be nested under workspaces).
  const source = workspace.defaultContextValue ? 'FORM' : 'WORKSPACE';

  const [labelModalState, setLabelModalState] = useState<{ modalOpen: boolean; values?: any; multiValue?: boolean }>({
    modalOpen: false,
  });

  const actionProps = useActionProps('products');

  let reloadData;
  let multiValue = false;
  let values;
  let count;
  switch (source) {
    case 'WORKSPACE':
      reloadData = workspace.reloadData;
      multiValue = true;
      count = workspace?.selectionState?.count;
      break;
    case 'FORM':
    default:
      reloadData = connectedForm.reloadData;
      values = connectedForm.values;
  }

  return [
    {
      key: 'printLabel',
      text: 'Print Label',
      onClick: () => {
        setLabelModalState({
          modalOpen: true,
        });
      },
      actionReference: ProductFormAction.PrintProductLabels,
    },
    <ModalContext.Provider
      value={{
        onClose: () => {
          setLabelModalState({ ...labelModalState, modalOpen: false });
          reloadData?.(true);
        },
      }}
    >
      <DocumentModal2
        modalOpen={labelModalState.modalOpen}
        multiValue={labelModalState.multiValue || multiValue}
        entity={ProductLabelBasic}
        title="Print Product Label(s)"
        values={labelModalState.values || values}
        modalWrapper={true}
        overrideActionProps={() => actionProps}
        count={count}
        outputSelection={[
          {
            value: 'LOCAL_PRINTER',
            label: 'Local Printer',
          },
          {
            value: 'SYSTEM_PRINTER',
            label: 'System Printer',
          },
          {
            value: 'PDF_ZIP',
            label: 'Individual PDFs',
          },
        ]}
      />
    </ModalContext.Provider>,
  ];
};
